namespace GeniuzPOS.Member {
    export namespace LookupMemberService {
        export const baseUrl = 'Member/LookupMember';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LookupMemberRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LookupMemberRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Member/LookupMember/Retrieve",
            List = "Member/LookupMember/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>LookupMemberService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
